import _ from 'lodash';

const toggleSelector = 'ul.accordion li [data-toggle=collapse]';

function setAccordionMinHeights() {
  $(toggleSelector).each((i, element) => {
    const $toggle = $(element);
    const $li = $toggle.parents('li');
    const totalHeight = $toggle.height() + parseFloat($toggle.css('margin-top')) + parseFloat($toggle.css('margin-bottom'));

    $li.css('min-height', `${totalHeight}px`);
  });
}

function setUpAccordionToggles() {
  $(document).on('click', toggleSelector, function clickHandler() {
    const $toggle = $(this);
    const $toggleIndicator = $toggle.children('span');
    const $li = $toggle.parents('li');

    $li.toggleClass('collapsed');
    $toggleIndicator.toggleClass('fa-plus');
    $toggleIndicator.toggleClass('fa-minus');
  });
}

export default function bootstrap() {
  setUpAccordionToggles();
  $(window).on('resize', _.throttle(() => setAccordionMinHeights(), 1000 / 60));
  setAccordionMinHeights();
}
